const BURLINGTONBUZZ_WORDS = [
  {
    date: "2025-04-17",
    hint: "A position nominated by a member of the board for Burlington's local government",
    word: "CHAIR",
    characterCount: 5,
    url: "https://www.burlington.buzz/local-government/board-reorganization-a-rotation-a-race-or-something-more-nuanced/",
  },
];

export const getWordForDate = (date) => {
  if (!date || !BURLINGTONBUZZ_WORDS || !Array.isArray(BURLINGTONBUZZ_WORDS)) {
    return null;
  }

  // Get current date
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  // Reset time parts for accurate date comparison
  const requestedDate = new Date(date);
  requestedDate.setHours(0, 0, 0, 0);

  // If requested date is in the future, return null
  if (requestedDate > currentDate) {
    return null;
  }

  // Format the date as YYYY-MM-DD
  const dateString =
    requestedDate.getFullYear() +
    "-" +
    String(requestedDate.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(requestedDate.getDate()).padStart(2, "0");

  return BURLINGTONBUZZ_WORDS.find((entry) => entry.date === dateString);
};

export const findLatestAvailableDate = () => {
  if (!BURLINGTONBUZZ_WORDS || !Array.isArray(BURLINGTONBUZZ_WORDS)) {
    return null;
  }

  // Get current date
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  // Create dates and filter out future dates
  const sortedEntries = BURLINGTONBUZZ_WORDS.map((entry) => ({
    date: new Date(entry.date + "T00:00:00"),
    original: entry,
  }))
    .filter((entry) => entry.date <= currentDate) // Filter out future dates
    .sort((a, b) => b.date - a.date);

  return sortedEntries[0]?.original;
};
